<template>
  <Accordion class="cn-accordion-new">
    <AccordionPanel v-for="(item, index) in items" :key="index" :value="index">
      <AccordionHeader>
        <template #default>
          <slot name="header" :item="item" :index="index" />
        </template>
        <template #toggleicon="{ active }">
          <UiIcon
            class="p-accordionheader-toggle-icon"
            :name="active ? 'chevron-down' : 'chevron-right'"
          />
        </template>
      </AccordionHeader>
      <AccordionContent>
        <slot name="content" :item="item" :index="index" />
      </AccordionContent>
    </AccordionPanel>
  </Accordion>
</template>

<script setup lang="ts">
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import UiIcon from '@/components/ui/UiIcon';

interface Props {
  items: unknown[];
}

defineProps<Props>();
</script>

<style lang="scss">
.cn-accordion-new {
  --accordion_color: #1b1b1b;
  --accordion__header_color: var(--accordion_color);
  --accordion__panel_color: var(--accordion_color);
  --accordion__header_highlight-color: var(--accordion_color);

  .p-accordionheader {
    color: var(--accordion__header_color);
    flex-direction: row-reverse;
    align-items: center;
    text-align: left;
    display: flex;
    width: 100%;

    > *:not(.p-accordionheader-toggle-icon) {
      flex-grow: 1;
    }

    &[data-p-active='true'] {
      color: var(--accordion__header_highlight-color);
    }
  }

  .p-accordionheader-toggle-icon {
    height: 24px;
    width: 24px;
  }

  .p-accordionpanel {
    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }

  .p-accordioncontent {
    color: var(--accordion__panel_color);
  }

  .p-collapsible-enter-active,
  .p-collapsible-leave-active {
    transition: opacity 0.2s ease;
  }
  .p-collapsible-enter-from,
  .p-collapsible-leave-to {
    opacity: 0;
  }
}
</style>
